import client from '../client'

export async function registerUser({
  firstName,
  lastName,
  email,
  phoneNumber,
  zipCode,
  password,
  confirmPassword,
}) {
  return client(
    `${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/${process.env.NEXT_PUBLIC_IDENTITY_VERSION}/user/registration`,
    {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        firstName,
        lastName,
        email,
        phoneNumber,
        zipCode,
        password,
        confirmPassword,
      }),
    },
  )
}
